<lib-filtered-table
  [isTreeTable]="true"
  [treeLabelTemplate]="label"
  [tableId]="'department_tree_table'"
  [columns]="columns()"
  [dataSource]="rows()"
  [showSearch]="false"
  [isLoadingData]="loading()"
  [treeSearchTemplateRef]="searchTemplateRef()"
  [tableActionSectionRef]="toolbarActionsTemplateRef()"
  [isTableExportable]="false"
  [tableFilterTabs]="[]"
  [tableClass]="'h-[calc(100vh-20rem)]'"
  [tableColumnTemplates]="[
    { template: identifier },
    { template: type },
    { template: track },
    { template: manager },
    { template: positions },
    { template: action },
  ]"
  [(payload)]="payload"
  [applyOnStreamChanges]="applyOnStreamChanges"
  [rowTestIdPrefix]="'department-row'"
  [toggleTestIdPrefix]="'department-toggle'"
  [expandAriaLabel]="'department_tree_expand_button'"
  [collapseAriaLabel]="'department_tree_collapse_button'"
  (toggleExpanded)="onToggleExpanded($event)"
  (handleRowClick)="selectRow($event)" />

<ng-template #label let-row>
  @if (row.department.image) {
    <img
      [src]="row.department.image.url"
      [alt]="row.department.image.name"
      width="28"
      height="28"
      class="rounded-sm size-7" />
  } @else {
    <span
      class="rounded-sm bg-primary-50 text-primary-500 flex justify-center items-center size-7">
      {{ row.department.name | avatar }}
    </span>
  }

  <span class="font-medium" [class.font-semibold]="row.depth === 0">
    {{ row.department.name | truncate }}
  </span>

  @if (row.subDepartmentsCount) {
    <span
      class="px-sm rounded-2xl bg-primary-50 text-primary-700 whitespace-nowrap">
      {{
        (row.subDepartmentsCount === 1
          ? 'department_tree_sub_department_badge'
          : 'department_tree_sub_departments_badge'
        ) | transloco: { count: row.subDepartmentsCount }
      }}
    </span>
  }
</ng-template>

<ng-template #identifier let-row>
  <span class="font-mono">{{ row.department.identifier }}</span>
</ng-template>

<ng-template #type let-row>
  {{ row.department.department_type?.label ?? '—' }}
</ng-template>

<ng-template #track let-row>
  @if (row.department.direct_manager?.position?.job_title?.track; as track) {
    <span class="px-sm rounded-sm bg-primary-50 text-primary-700">
      {{ track.label }}
    </span>
  } @else {
    —
  }
</ng-template>

<ng-template #manager let-row>
  <span class="font-mono">
    {{ row.department.direct_manager?.position?.identifier ?? '—' }}
  </span>
</ng-template>

<ng-template #positions let-row>
  <span class="font-semibold">
    {{ row.ownPositionsCount }}
    @if (row.totalPositionsCount !== row.ownPositionsCount) {
      <span class="font-normal text-neutral-400">
        ({{ row.totalPositionsCount }})
      </span>
    }
  </span>
</ng-template>

<ng-template #action let-row>
  <div data-row-click-ignore>
    @if (actionTemplate(); as template) {
      <ng-container
        *ngTemplateOutlet="template; context: { $implicit: row.department }" />
    }
  </div>
</ng-template>
